"use strict";

exports.__esModule = true;
exports.dataItemIndexArray = void 0;
var dataItemIndexArray = exports.dataItemIndexArray = [{
  dataItemIndex: 0,
  translationKey: "DataItem.dataItem.parameter1",
  dataItemLabel: "Parameter 1"
}, {
  dataItemIndex: 1,
  translationKey: "DataItem.dataItem.parameter2",
  dataItemLabel: "Parameter 2"
}, {
  dataItemIndex: 2,
  translationKey: "DataItem.dataItem.parameter3",
  dataItemLabel: "Parameter 3"
}, {
  dataItemIndex: 3,
  translationKey: "DataItem.dataItem.parameter4",
  dataItemLabel: "Parameter 4"
}, {
  dataItemIndex: 4,
  translationKey: "DataItem.dataItem.parameter5",
  dataItemLabel: "Parameter 5"
}, {
  dataItemIndex: 5,
  translationKey: "DataItem.dataItem.parameter6",
  dataItemLabel: "Parameter 6"
}];